var React = require('react');

function Language (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 1.5C6.204 1.5 1.5 6.204 1.5 12S6.204 22.5 12 22.5 22.5 17.796 22.5 12 17.796 1.5 12 1.5m-1.05 18.826A8.388 8.388 0 013.6 12c0-.651.084-1.281.22-1.88l5.03 5.03v1.05c0 1.155.945 2.1 2.1 2.1m7.245-.64A2.106 2.106 0 0016.2 16.2h-1.05v-3.15c0-.578-.473-1.05-1.05-1.05H7.8V9.9h2.1c.577 0 1.05-.473 1.05-1.05v-2.1h2.1c1.155 0 2.1-.945 2.1-2.1v-.43a8.383 8.383 0 013.045 13.44","fillRule":"evenodd"}));
}

Language.defaultProps = {"width":"24","height":"24"};

module.exports = Language;

Language.default = Language;
